const StatusPill = ({ value }) =>
  value ? <span className="pill pill-success">Yes</span> : <span className="pill pill-neutral">No</span>

export default StatusPill
